<script setup>
import { computed } from 'vue';
import { AlarmClockIcon } from '@hugeicons/core-free-icons';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import HugeIcon from 'dashboard/components-next/icon/HugeIcon.vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
import {
  formatActivityActorBoldHtml,
  isSnoozeRelatedActivityContent,
  stripHtmlForActivity,
} from 'dashboard/helper/activityContentDisplay.js';

const props = defineProps({
  actorNames: {
    type: Array,
    default: () => [],
  },
});

const { content, createdAt } = useMessageContext();

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a')
);

const displayHtml = computed(() =>
  formatActivityActorBoldHtml(content.value, props.actorNames)
);

const showSnoozeIcon = computed(() =>
  isSnoozeRelatedActivityContent(content.value)
);

const plainTitle = computed(() => stripHtmlForActivity(content.value));
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="flex max-w-full min-w-0 items-center justify-center gap-1.5 px-2 py-0.5 text-center !text-xs font-normal leading-snug text-n-slate-10 [&_strong]:text-[11px] [&_strong]:font-semibold"
    data-bubble-name="activity"
  >
    <HugeIcon
      v-if="showSnoozeIcon"
      :icon="AlarmClockIcon"
      :size="14"
      class="shrink-0 text-n-slate-9"
    />
    <span v-dompurify-html="displayHtml" :title="plainTitle" />
  </BaseBubble>
</template>
